import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";

interface CreatePaymentIntentRequest {
  amount?: number;
  customerId?: string;
  paymentMethodId?: string;
  paymentMethodTypes: string[];
  userId?: string;
  discountCode?: string;
  productId?: string;
  isAnnual?: boolean;
  name?: string;
  email?: string;
  IsEventEarlyBird?: boolean;
  isEvent?: boolean;
}

interface CreatePaymentIntentResponse {
  clientSecret: string;
  customerId?: string;
  paymentMethodId?: string;
  /** When true, payment already succeeded on server; frontend should skip confirmCardPayment. */
  paymentAlreadySucceeded?: boolean;
}

export const useMakePayment = (
  options?: UseMutationOptions<
    CreatePaymentIntentResponse,
    unknown,
    CreatePaymentIntentRequest,
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationFn: (data: CreatePaymentIntentRequest) =>
      axiosInstance
        .post(getAPIURL("/Payment/create-payment-intent"), data)
        .then((res) => res.data),
  });
};
